import { chatConfig } from '../config/chatConfig';

const TEMP_PREFIX = chatConfig.identifiers.tempIdPrefix;

export const isTempMessageId = (id: string | undefined | null): boolean => {
  return typeof id === 'string' && id.startsWith(TEMP_PREFIX);
};
